export const closeOpenedQuickFilterInputs = quickFilters => {
  quickFilters.map(filter => {
    const element = document.getElementById(`popover-trigger-${filter.name}-quick-filters`);

    if (element) {
      const isOpen = element.getAttribute('aria-expanded');

      if (isOpen === 'true') {
        element.click();
      }
    }
  });
};
